<template>
  <mia-checkbox
    class="w-5 h-5"
    :checked="isChecked"
    @click="onClick"
    @change="onChange"
  />
</template>

<script>
import findIndex from 'lodash/findIndex'

export default {
  name: 'MiaDatatableCheckboxColumn',

  props: {
    column: {
      type: Object,
      default() {
        return {}
      }
    },

    row: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {
      wasShiftKeyPressed: false
    }
  },

  computed: {
    isChecked() {
      const meta = this.column.meta || {}
      const isChecked = meta.isChecked || (row => row.isChecked)

      return isChecked(this.row)
    }
  },

  methods: {
    onClick(event) {
      this.wasShiftKeyPressed = event.shiftKey
    },

    onChange(event) {
      /* eslint-disable no-underscore-dangle */
      if (!this.wasShiftKeyPressed) {
        this.$parent.$parent.__cbColumnPrevious = this.row.id
        this.$parent.$parent.$emit(event.target.checked ? 'checked' : 'unchecked', this.getPayload([this.row]))
        return
      }

      if (this.$parent.$parent.__cbColumnPrevious === this.row.id) {
        return
      }

      const previousRowIndex = findIndex(this.$parent.$parent.displayedRows, ['id', this.$parent.$parent.__cbColumnPrevious])
      const currentRowIndex = findIndex(this.$parent.$parent.displayedRows, ['id', this.row.id])

      let lower = previousRowIndex
      let upper = currentRowIndex

      if (currentRowIndex < previousRowIndex) {
        lower = currentRowIndex
        upper = previousRowIndex
      }

      this.$parent.$parent.$emit(event.target.checked ? 'checked' : 'unchecked', this.getPayload(this.$parent.$parent.displayedRows.slice(lower, upper + 1)))
      this.$parent.$parent.__cbColumnPrevious = this.row.id
      /* eslint-enable no-underscore-dangle */
    },

    getPayload(items) {
      const meta = this.column.meta || {}
      const { only } = meta

      if (only) {
        return items.map(item => item[only])
      }

      return items
    }
  }
}
</script>
